import { createContext } from "react";

export type MaintenanceContextProps = {
  from?: string | number | null
  to?: string | number | null;
}

export const MaintenanceContext = createContext<MaintenanceContextProps>({});